import { render, staticRenderFns } from "./GoodsInfo.vue?vue&type=template&id=7caf6a32&scoped=true"
import script from "./GoodsInfo.vue?vue&type=script&lang=js"
export * from "./GoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfo.vue?vue&type=style&index=0&id=7caf6a32&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf6a32",
  null
  
)

export default component.exports